import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { PersonCircle, BoxArrowRight, Gear } from 'react-bootstrap-icons';

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!user) return null;

  return (
    <div className="sm-user-menu" ref={dropdownRef}>
      <button
        className={`sm-user-menu__trigger ${isOpen ? 'sm-user-menu__trigger--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="User menu"
      >
        <PersonCircle size={22} className="sm-user-menu__trigger-icon" />
      </button>

      {isOpen && (
        <div className="sm-user-menu__dropdown sm-animate-slide-down">
          {/* Top decorative border */}
          <div className="sm-user-menu__dropdown-line" />
          
          <div className="sm-user-menu__info">
            <div className="sm-user-menu__label">
              <Gear size={14} className="sm-user-menu__label-icon" />
              <span className="sm-user-menu__label-text">Logged in as</span>
            </div>
            <strong className="sm-user-menu__email" title={user.email}>
              {user.email}
            </strong>
          </div>
          
          <div className="sm-user-menu__divider" />
          
          <div className="sm-user-menu__actions">
            <button
              className="sm-user-menu__logout"
              onClick={() => {
                logout();
                setIsOpen(false);
              }}
            >
              <BoxArrowRight className="sm-user-menu__logout-icon" size={16} />
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
